<script>
import Layout from '@/Shared/layout/editor'
import { Link } from '@inertiajs/vue3'

import { queueScreenshotCaptures } from '@/Shared/screenshotQueue'

export default {
  layout: (h, page) => h(Layout, { padded: true }, () => page),

  mounted() {
    queueScreenshotCaptures(this.$page.props.pending_capture_urls)
  },

}
</script>

<script setup>
defineProps({ user: Object, pages: Object, portfolio: Object, sites: Object})
</script>

<template>

<div class="flex">
  <!-- <div>
    <h1 class="text-2xl">Welkom Sesayars,</h1>
    <p>All information you will need!</p>
  </div>
    <div class="flex-1"></div> -->
  <div class="flex items-center w-full">
    <h1 class="text-xl font-semibold">Pages</h1>
  </div>
</div>

<!-- pages -->
<div class="flex flex-wrap gap-4 mt-6">
<template v-for="page in pages">
  <Link :href="'/site/'+sites.uuid+'/page/'+page.uuid" class="hover:opacity-70" style="min-width: calc(100% / 5); max-width: calc(100% / 5);">
    <div class="rounded-xl bg-bay w-full h-48" :style="'border: 1px solid #ddd; background:url('+page.image+'); background-size:cover; background-position: center;'"></div>
    <h4 class="font-semibold pb-2 pt-3">{{ page.name }}</h4>
    <label class="text-sm">https://{{ sites.domain }}{{ page.path }}</label>
  </Link>
</template>
</div>



<h3 class="text-lg mt-8 font-semibold">Portfolio</h3>
<hr class="mt-4">
<!-- portfolio -->
<div class="flex flex-wrap gap-4 mt-6">

  <Link :href="'/site/'+sites.uuid+'/create/portfolio'" class="hover:opacity-70" style="min-width: calc(100% / 5); max-width: calc(100% / 5);">
    <div class="rounded-xl bg-bay w-full h-48" :style="'border: 1px solid #ddd; background:#ececec; background-size:cover; background-position: center;'">
      <h1 style="
      font-size: 5rem;
      color: #2d2d2d;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      height: calc(100% - 1rem);
      ">+</h1>
    </div>
    <h4 class="font-semibold pb-2 pt-3">Portfolio Item</h4>
    <label class="text-sm">Create a new portfolio item</label>
  </Link>

  <template v-for="page in portfolio">
  <Link :href="'/site/'+sites.uuid+'/page/'+page.uuid" class="hover:opacity-70" style="min-width: calc(100% / 5); max-width: calc(100% / 5);">
    <div class="rounded-xl bg-bay w-full h-48" :style="'border: 1px solid #ddd; background:url('+page.image+'); background-size:cover; background-position: center;'"></div>
    <h4 class="font-semibold pb-2 pt-3">{{ page.name }}</h4>
    <label class="text-sm">https://{{ sites.domain }}{{ page.path }}</label>
  </Link>
</template>
</div>




</template>